<template>
  <div class="box-container">
    <div :class="[{ 'completed': completed }, 'header']" @click.stop="collapsed = !collapsed">
      <span class="float-right collapse-button">
        <span v-if="collapsed && !completed" >
          <i class="fad fax fa-arrow-circle-down"></i>
        </span>
        <span v-if="!collapsed && !completed">
          <i class="fad fax fa-arrow-circle-up"></i>
        </span>
        <span v-if="completed">
          <i class="fa fax fa-check-square"></i>
        </span>

      </span>
      <p class="title">
        <i class="fa fax fa-book"></i>
        <span class="title">{{ group.name }}</span>
      </p>
    </div>
    <div class="content" v-if="!collapsed">
      <p v-html="group.description"></p>

      <document-group-type
              :summary="summary"
              :key="type.id"
              :type="type"
              v-for="(type, index) in group.types"
              :index="index"
              @file-upload="handleFileUpload"
              @file-removed="handleFileRemoved"
              :person-can-upload="personCanUpload"
              :partner-can-upload="partnerCanUpload"
      />
    </div>
  </div>
</template>
<script>
import DocumentGroupType from '@/components/_registration/DocumentGroupType'

export default {
  components: { DocumentGroupType },
  data: () => {
    return {
      collapsed: true,
    }
  },
  props: {
    index: {
      type: Number,
      default: null,
    },
    group: {
      type: Object,
      default: () => {
        return {
          description: '',
          id: '',
          name: '',
          types: [],
        }
      }
    },
    summary: {
      type: Object,
      default: () => {}
    },
  },
  methods: {
    handleFileUpload(file, typeIndex){
      this.$emit('file-upload', file, typeIndex, this.index)
    },
    handleFileRemoved(typeIndex, fileIndex){
      this.$emit('file-removed', this.index, typeIndex, fileIndex )
    }
  },
  computed: {
    completed(){
      if(this.summary.partner === undefined || !this.summary.partner.hasPartner){
        return (this.group.currentDocumentCount > 0)
      } else {
        return (this.group.currentDocumentCount > 0 && this.group.currentPartnerDocumentCount > 0)
      }
    },
    partnerCanUpload() {
      // Geen partner => partner mag niet uploaden
      if(this.summary.partner === undefined || !this.summary.partner.hasPartner){
        return false
      }

      // Geen basic groep betekent dat er altijd extra mag worden geupload
      if (!this.group.isBasic){
        return true
      }

      // Een partner, maar een basic group, mag alleen uploaden als er nog GEEN doc voor partner is geupload.
      return (this.group.currentPartnerDocumentCount === 0)
    },

    personCanUpload() {
      /*
        // Geen basic groep betekent dat er altijd extra mag worden geupload
        if (!this.group.isBasic){
          return true
        }

        // Een basic group, mag alleen uploaden als er nog GEEN doc voor person is geupload.
        return (this.group.currentDocumentCount === 0)

        // Leaving the code above in, but why? You should always be able to upload.
      */
      return true;
    },
  },
}
</script>
<style lang="scss" scoped>
.box-container {
  border: 1px solid #009e0f;
  border-radius: 3px;
  margin-top: 10px;
}

.header {
  margin-bottom: 0;
  cursor: pointer;
  color: #333;
  padding: 5px 5px 5px 5px;

  &.completed {
    background-color: #009e0f;
    color: #ffffff;
  }


  i.icon {
    font-size: 30px;
    vertical-align: middle;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    padding-left: 10px;
    vertical-align: middle;
    margin-bottom: 0;
  }
}

.content {
  padding: 0 20px 20px 20px
}

.message {
  color: #009e0f;
  font-weight: bold;
  margin-top: 1rem;
  display: block;
}

.collapse-button {
  padding: 4px;
  font-size: 25px;
}
</style>